import React, {useEffect} from "react";
import {Link} from "react-router-dom";

import {makeStyles} from '@material-ui/core/styles';

import Add from "@material-ui/icons/AddBox";

import {LANGUAGE} from "config/const";

import Button from "components/CustomButtons";
import CustomInput from "components/CustomInput";
import CustomDialog from "components/CustomDialog";
import CustomSelect from "components/CustomSelect";
import Navbar from "components/Navbars";

import useProject from "hooks/useProject";
import useUser from "hooks/useUser";
import Typography from "@material-ui/core/Typography";

import {
  headerHeight,
} from "assets/jss/index.js";
import useError from "hooks/useError";

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
    margin: headerHeight + 10 + "px 10px 10px"
  },
  button: {
    width: 200,
    height: 150,
    '& svg': {
      marginLeft: 5
    }
  },
}));

export default function Top() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [project, setProject] = React.useState({
    displayName: '',
    name: '',
    languageCode: LANGUAGE.CODE.JAPANESE,
    iosBundleId: '',
    androidBundleId: ''
  });
  const projectHook = useProject();
  const userHook = useUser();
  const errorHook = useError();

  useEffect(() => {
    projectHook.fetchProjectList();
  }, []);

  window.document.title = `管理システム`;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!project.displayName || !project.name || !project.languageCode) {
      errorHook.showError('パラメーターが不足しています');
      return;
    }

    projectHook.create(project);
    setOpen(false);
    setProject(project);
  };

  const handleChange = (key, value) => {
    // console.log('change', key, value);
    let _project = Object.assign({}, project);
    _project[key] = value;
    setProject(_project)
  };

  const projectList = () => {
    // 削除されていない＆（オーナーorプロジェクトメンバー）
    return projectHook.projects.filter(pj => pj.deleteFlag === 0).map((prop, key) => {
      if (userHook.isOwner() || userHook.isProjectMember(prop.id)) {
        return (
          <Link to={{pathname: `/project/${prop.name}/overview`}} key={key}>
            <Button color="info" id={prop.name} key={key} className={classes.button}>
              <div style={{display: 'block'}}>
                <Typography variant="h5">
                  {prop.displayName}
                </Typography>
                <Typography variant="subtitle2">
                  {prop.name}
                </Typography>
                <Typography variant="caption">
                  [ 言語: {(() => {
                    switch (prop.languageCode) {
                      case LANGUAGE.CODE.JAPANESE: return LANGUAGE.NAME.JAPANESE;
                      case LANGUAGE.CODE.KOREAN: return LANGUAGE.NAME.KOREAN;
                      default: return '-';
                    }
                  })()} ]
                </Typography>
              </div>
            </Button>
          </Link>
        )
      } else {
        return null;
      }
    })
  };

  return (
    <div>
      <Navbar/>
      <div className={classes.root}>
        {userHook.isOwner() ?
          <Button variant="outlined" onClick={handleClickOpen} className={classes.button}>
            プロジェクトの追加<Add/>
          </Button>
          :
          null}
        {projectList()}
      </div>

      <CustomDialog
        open={open}
        onClose={handleClose}
        dialogTitle={"プロジェクトの追加"}
        dialogContent={
          <div>
            <CustomInput
              labelText="プロジェクト名"
              id="project-name"
              inputProps={{
                value: project.displayName,
                onChange: e => handleChange('displayName', e.target.value)
              }}
            />
            <CustomInput
              labelText="プロジェクトID"
              id="project-id"
              inputProps={{
                value: project.name,
                placeholder: "英数字のみ入力してください",
                onChange: e => handleChange('name', e.target.value),
                type: 'hankaku'
              }}
            />
            <CustomSelect
              labelText="言語"
              data={[
                // code = ISO 639-1
                {code: LANGUAGE.CODE.JAPANESE, name: LANGUAGE.NAME.JAPANESE},
                {code: LANGUAGE.CODE.KOREAN, name: LANGUAGE.NAME.KOREAN},
              ]}
              labelProps={{
                required: true
              }}
              textField="name"
              valueField="code"
              selectProps={{
                defaultValue: LANGUAGE.CODE.JAPANESE,
                onChange: (e) => handleChange('languageCode', e.target.value)
              }}
            />
            <CustomInput
              labelText="iOSバンドルID"
              id="iosBundleId"
              inputProps={{
                value: project.iosBundleId,
                placeholder: "英数字のみ入力してください",
                onChange: e => handleChange('iosBundleId', e.target.value),
                type: 'hankaku'
              }}
            />
            <CustomInput
              labelText="AndroidバンドルID"
              id="androidBundleId"
              inputProps={{
                value: project.androidBundleId,
                placeholder: "英数字のみ入力してください",
                onChange: e => handleChange('androidBundleId', e.target.value),
                type: 'hankaku'
              }}
            />
          </div>
        }
        dialogActions={
          <div>
            <Button onClick={handleClose}>
              キャンセル
            </Button>
            <Button onClick={handleSubmit} color="primary">
              追加
            </Button>
          </div>
        }
      />
    </div>
  )

}
